import React, { useEffect, useState } from "react";
import "../style/contact.css";
import { Card, CardContent, Grid, TextField, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { IoLocation } from "react-icons/io5";
import { MdEmail } from "react-icons/md";
import { FaPhoneAlt } from "react-icons/fa";
import Footer from "../components/Footer";
import Angebot from "./Angebot";

function Contact() {
  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  const [result, setResult] = React.useState("");
  const [messageColor, setMessageColor] = React.useState("text-green-500");

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);

    formData.append("access_key", "8ba0eda1-f2cc-4b67-8b87-429a9bda01dc");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      setMessageColor("text-green-500");
      setResult("Message Send Successfully");
      event.target.reset();
      setTimeout(() => {
        setResult("");
      }, 5000);
    } else {
      console.log("Error", data);
      setResult(data.message);
    }
  };

  return (
    <div className="contact-container">
      <div className="flex-box-contact">
        <div className="first-container-contact">
          <div className="text-contact">
            <Typography
              gutterBottom
              variant="h2"
              sx={{
                fontFamily: " Rubik,sans-serif !important",
                fontWeight: "bold",
                color: "#474747",
              }}
            >
              Jetzt Reinigung anfragen
            </Typography>
          </div>
          <div className="second-text-contact">
            <Typography
              gutterBottom
              variant="body2"
              className="text-body-contact"
            >
             Schnell, unverbindlich und kostenlos.
            </Typography>
          </div>
          <div className="contact-forma">
            <div className="contact-forma-text">
              <Card>
                <CardContent>
                  <Typography
                    gutterBottom
                    variant="h4"
                    className="contact-body-us"
                  >
                    Kontaktiere uns
                  </Typography>
                  <Typography
                    gutterBottom
                    variant="body2"
                    sx={{
                      paddingBottom: "20px",
                      color: "#A5A5A5",
                    }}
                  >
                    Füllen Sie das Formular aus und unser Team wird sich
                    innerhalb von 24 Stunden bei Ihnen melden.
                  </Typography>
                  <form onSubmit={onSubmit}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          className="text-field-focus"
                          htmlFor="email"
                          id="name"
                          type="text"
                          name="name"
                          label="First Name"
                          variant="outlined"
                          fullWidth
                          required
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          className="text-field-focus"
                          htmlFor="email"
                          name="lastname"
                          id="lastName"
                          type="text"
                          label="Last Name"
                          variant="outlined"
                          fullWidth
                          required
                        />
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <TextField
                          className="text-field-focus"
                          htmlFor="email"
                          id="email"
                          type="email"
                          name="email"
                          label="Enter your email"
                          variant="outlined"
                          fullWidth
                          required
                        />
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <TextField
                          className="text-field-focus"
                          type="phone"
                          name="phone"
                          label="Enter your phone number"
                          variant="outlined"
                          fullWidth
                          required
                        />
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <TextField
                          className="text-field-focus"
                          id="message"
                          name="message"
                          label="Message"
                          multiline
                          rows={6}
                          variant="outlined"
                          fullWidth
                          required
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          fullWidth
                          sx={{
                            backgroundColor: "var(--mainColorLight)",

                            "&:hover": {
                              backgroundColor: "#01b8c3",
                            },
                          }}
                        >
                          Send
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                  {result && <p className={`mt-2 ${messageColor}`}>{result}</p>}
                </CardContent>
              </Card>
            </div>
            <div className="conctat-information-text">
              <div className="text-box-div">
                <div className="text-contact-information">
                  <Typography
                    variant="h4"
                    className="text-info-kontakt"
                    sx={{
                      color: "var(--mainColor)",
                      fontFamily: "Rubik,sans-serif",
                    }}
                  >
                    Kontakt
                  </Typography>
                </div>
                <div className="infot-kontakt">
                  <Typography
                    variant="body1"
                    className="info-kontakt-text"
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    {" "}
                    <FaPhoneAlt style={{ marginRight: "20px" }} /> +491742500990
                  </Typography>
                  <Typography
                    variant="body1"
                    className="info-kontakt-text"
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    {" "}
                    <MdEmail
                      style={{ marginRight: "20px", fontSize: "26px" }}
                    />{" "}
                    info@rein-cleaning.de
                  </Typography>
                  <Typography
                    variant="body1"
                    className="info-kontakt-text"
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <IoLocation
                      style={{ marginRight: "20px", fontSize: "26px" }}
                    />{" "}
                    Nosthoffen Straße 27,
                    <br />
                    Dusseldorf Germany
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full h-22">
        <Angebot />
      </div>
      <Footer />
    </div>
  );
}

export default Contact;
